import React, { Component } from 'react'
import './style.css'
import List from '../../../components/List'
import Dropdown from '../../../components/Dropdown'

class RequestsList extends Component {

  state = {
    filter: 'Default'
  }

  render() {

    const { filter } = this.state

    const requests = this.props.requests.filter(({ state, ended }) => {
      if (filter === "EN-COURS") return state === "ACCEPTEE" && !ended
      if (filter === "Default") return state === "ENVOYEE" || state === "ACCEPTEE"
      return filter === "ALL" || state === filter
    })

    return <React.Fragment>
      <List
            header={
              <React.Fragment>
                <Dropdown
                  label={<span><i className="fas fa-filter"></i> {filter}</span>} 
                  options={[{
                    label: "Default",
                    value: "Default"
                  },{
                    label: "En cours",
                    value: "EN-COURS"
                  },{
                    label: "All",
                    value: "ALL"
                  },{
                    label: "Envoyée",
                    value: "ENVOYEE"
                  },{
                    label: "Acceptée",
                    value: "ACCEPTEE"
                  },{
                    label: "Annulée",
                    value: "ANNULEE"
                  }]}
                  onSelect={filter => this.setState({ filter })}
                  />
                  <span>{requests.length}</span>
                </React.Fragment>
              }
              list={
                requests.map(({ _id, state, request_students, tutor }) => ({
                  link: `/requests/${_id}`,
                  active: _id === this.props.active,
                  title: request_students.map(({ student: { first_name } }, i) => <div key={i}>
                    <b>{first_name}</b>
                  </div>),
                  body: tutor && <div>
                      <div>{tutor.user.first_name} {tutor.user.last_name}</div>
                    </div>,
                  footer: <small className={'state ' + state}>{state}</small>
                }))
              }
            />
    </React.Fragment> 
  }
}

export default RequestsList;



// WEBPACK FOOTER //
// ./src/containers/requests/List/index.js